/* eslint-disable */

import React from 'react';
import { Input, Select } from 'antd';

export function LicenseFormFields({
  isEdit,
  name,
  onNameChange,
  selectedLicenseId,
  onLicenseSelect,
  licenses,
  description,
  onDescriptionChange,
}) {
  return (
    <div className='license-form-fields'>
      <label className='license-form-field'>
        <span className='license-form-label'>
          ชื่อใบทะเบียน (Registration Name)
          <span className='license-form-required'>*</span>
        </span>
        {isEdit ? (
          <Select
            value={selectedLicenseId || undefined}
            onChange={onLicenseSelect}
            placeholder='เลือกชื่อใบทะเบียน เช่น ขย.1, ขย.2'
            className='license-form-select'
            options={licenses.map((license) => ({
              value: license.id,
              label: license.name,
            }))}
            showSearch
            optionFilterProp='label'
            allowClear
          />
        ) : (
          <Input
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
            placeholder='กรอกชื่อใบทะเบียน เช่น ขย.1, ขย.2'
            className='license-form-input'
          />
        )}
      </label>
      <label className='license-form-field'>
        <span className='license-form-label'>รายละเอียด (Description)</span>
        <Input
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          placeholder={
            isEdit && !selectedLicenseId
              ? 'เลือกใบทะเบียนก่อนเพื่อแสดงรายละเอียด'
              : 'กรอกรายละเอียดเงื่อนไขและข้อกำหนดสำหรับใบทะเบียนนี้'
          }
          className='license-form-input'
          disabled={isEdit && !selectedLicenseId}
        />
      </label>
    </div>
  );
}
